import { useLingui } from "@lingui/react/macro"
import * as React from "react"

import { useScrollToHeroForm } from "../../dato-components/dato-hero-section/dato-hero-form/helpers"
import Button from "../../design-system/button"
import { usePageContext } from "../../utils/contexts/page-context"
import { useSettingsByPath } from "../../utils/url-params"
import LegalDisbursementModalButton from "../legal-disbursements-modal/button"

interface Props {
  className?: string
  fullWidth?: boolean
  target?: "_blank"
  size?: "medium" | "large"
  text?: string
  buttonLocation: string
  buttonPosition?: string
  // if href is not provided, the button will scroll to top
  href?: string
  onMouseUp?: () => void
  variant?: "primary" | "secondary"
}

function ButtonBookDemo({
  target,
  buttonLocation,
  buttonPosition = "1",
  text,
  href,
  onMouseUp,
  variant = "primary",
  ...props
}: Props) {
  const { t } = useLingui()
  const { pathname } = usePageContext()
  const { leadLevel } = useSettingsByPath(pathname)
  const scrollToHeroForm = useScrollToHeroForm()
  const shouldScrollToFormOnClick = !href

  const localizedLabel = text || t`Book a demo`

  const commonButtonProps = {
    trackingProperties: {
      buttonName: "Book a demo",
      buttonLocation,
      buttonPosition,
    },
    ...props,
  }

  if (pathname.includes("legal-disbursements")) {
    return (
      <LegalDisbursementModalButton
        buttonLocation={buttonLocation}
        {...commonButtonProps}
      />
    )
  }

  const clickProps = shouldScrollToFormOnClick
    ? {
        onClick: scrollToHeroForm,
      }
    : ({
        as: "a",
        href,
        target,
        onMouseUp,
      } as const)

  return (
    <Button
      data-testid="button-book-demo"
      state={{ leadLevel }}
      {...clickProps}
      {...commonButtonProps}
      variant={variant}
    >
      {localizedLabel}
    </Button>
  )
}

export default ButtonBookDemo
